import { URLS } from '../../../constants';
import apiClient from '../../client';

const InsuranceGridApi = {
  getInsuranceGridApi: ({
    heading,
    roleId,
    type,
    assignedTo,
    pagination,
    order,
    name,
    filterValue,
  }: {
    heading: string;
    roleId: string;
    type: string;
    assignedTo: string;
    pagination: {
      startIndex: number;
      noOfRecords: number;
    };
    name: string;
    order: string;
    filterValue: string;
  }) =>
    apiClient.post(URLS.insuranceGridUrl, {
      data: {
        heading,
        roleId,
        type,
        pagination,
        assignedTo,
        filter: [
          {
            filterKey: 'name',
            filterValue: filterValue || '',
          },
        ],
        sorting: {
          order: order || 'DESC',
          fieldName: name || 'createdDate',
        },
      },
    }),
  addNewInsurance: ({
    id,
    name,
    payerId,
    addressLine1,
    addressLine2,
    city,
    state,
    zipCode,
    country,
  }: {
    id: any;
    name: any;
    payerId: any;
    addressLine1: any;
    addressLine2: any;
    city: any;
    state: any;
    zipCode: any;
    country: any;
  }) =>
    apiClient.post(URLS.insuranceAddNew, {
      data: {
        id,
        name,
        payerId,
        addressLine1,
        addressLine2,
        city,
        state,
        zipCode,
        country,
      },
    }),
  getInusrnaceById: ({ id }: { id: any }) =>
    apiClient.post(URLS.getInsuranveById, {
      data: {
        id,
      },
    }),
};
export default InsuranceGridApi;
